import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "referral-note" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Customize your Invitation", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, "A personal message can go a long way!", -1 /* HOISTED */)
const _hoisted_4 = { class: "input-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode($setup["TextField"], {
        class: "note",
        label: "Message",
        modelValue: $setup.message,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.message) = $event))
      }, null, 8 /* PROPS */, ["modelValue"])
    ]),
    _createElementVNode("div", { class: "btn-container" }, [
      _createElementVNode("button", {
        class: "borderless toHome",
        onClick: $setup.previous
      }, "Back"),
      _createElementVNode("button", {
        class: "primary start",
        onClick: $setup.setNote
      }, "Continue")
    ])
  ]))
}